const state = {
    promptText: null,
    proceed: false,
    proceedAction: null,
    proceedArguments: [],
    promptComment: null,
    promptSettings: null,
    stashedCancel: null,
    onPromptCancel: null,
    doNotShowAgainBool: false,
    doNotShowAgainVal: {}
  }
  const getters = {
    getPromptText: state => state.promptText, 
    isPromptProceed: state => state.proceed,
    getProceedAction: state => state.proceedAction,
    getProceedArgs: state => state.proceedArguments,
    getPromptComment: state => state.promptComment,
    getPromptSettings: state => state.promptSettings,
    getOnPromptCancel: state => state.onPromptCancel,
    doNotShowBool: state => state.doNotShowAgainBool,
    getPromptDoNotShows: state => state.doNotShowAgainVal
  }
  const mutations = {
    setPrompt(state, [promptText, promptAction, promptArguments, promptSettings, onCancel]) {
      state.proceed = false
      state.promptText = promptText
      state.proceedAction = promptAction
      state.proceedArguments = promptArguments
      state.promptSettings = promptSettings
      state.onPromptCancel = null
      state.stashedCancel = onCancel
    },
    closePrompt(state) {
      state.promptText = null
      state.proceedAction = null
      state.proceed = false
      state.proceedArguments = []
      state.promptSettings = null
      if (state.stashedCancel) state.onPromptCancel = state.stashedCancel
    },
    proceedPrompt(state) {
      if (!state.promptSettings?.keepOpenAfterProceed) state.promptText = null
      if (state.proceedAction !== 'closePrompt' && !state.promptSettings?.keepProceedFalse) {
        state.proceed = true
      }
      else if (state.proceedAction === 'closePrompt') {
        state.proceedAction = null
        state.proceed = false
      }
    },
    setProceedArgs(state, args) {
      state.proceedArguments = args
    },
    setPromptComment(state, comment) {
      state.promptComment = comment
    },
    setProceedAction(state, [proceedAction, proceedArguments]) {
      state.proceedAction = proceedAction
      if (proceedArguments) state.proceedArguments = proceedArguments
    },
    setPromptSettings(state, promptSettings) {
      state.promptSettings = promptSettings
    },
    setPromptDoNotShowAgainBool(state, bool) {
      state.doNotShowAgainBool = bool
    },
    setPromptDoNotShow(state, [key, val]) {
      state.doNotShowAgainVal[key] = val
    }
  }
  
  export default {
    state,
    getters,
    mutations
  }